export enum TaskTableNamesEnum {
  'Overview' = 'Overview',
  'Log' = 'Log',
  'HaccpLog' = 'HaccpLog',
}
